import React, { useState } from 'react';
import Pagination from 'react-bootstrap/Pagination';

export default function Paginations({ currentPage, setCurrentPage, totalItemsPerPage, totalItems }) {
  const ITEMS_PER_PAGE = totalItemsPerPage;
  const TOTAL_ITEMS = totalItems;
  const totalPages = Math.ceil(TOTAL_ITEMS / ITEMS_PER_PAGE);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Pagination>
      <Pagination.First onClick={() => handlePageChange(1)} />
      <Pagination.Prev
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
      {Array.from({ length: totalPages }).map((_, index) => (
        <Pagination.Item
          key={index}
          active={index + 1 === currentPage}
          onClick={() => handlePageChange(index + 1)}
        >
          {index + 1}
        </Pagination.Item>
      ))}
      <Pagination.Next
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
      <Pagination.Last onClick={() => handlePageChange(totalPages)} />
    </Pagination>
  )
}
